import React, { useState } from "react";
import { ResultDataCards } from "./ResultDataCards";
import { ResultBarChart } from "./ResultBarChart";
import { StudentList } from "./StudentList";
import { FunnelMapKeys } from "@/util/funnelGroups";

interface ResultsProps {
  eventId: string;
}

export const Results = ({ eventId }: ResultsProps) => {
  const [selectedBarGroup, setSelectedBarGroup] =
    useState<FunnelMapKeys<"CURRENT_FUNNEL_STATE_CHART"> | null>(null);

  const handleBarSelection = (
    groupKey: FunnelMapKeys<"CURRENT_FUNNEL_STATE_CHART"> | null,
  ) => {
    setSelectedBarGroup(groupKey);
  };

  return (
    <div className="space-y-6">
      {/* Data Cards */}
      <ResultDataCards eventId={eventId} />

      {/* Bar Chart */}
      <ResultBarChart
        eventId={eventId}
        selectedBarGroup={selectedBarGroup}
        onBarSelection={handleBarSelection}
      />

      {/* Student List */}
      <StudentList liveEventId={eventId} selectedBarGroup={selectedBarGroup} />
    </div>
  );
};
